export default "__VITE_ASSET__Cwlh3oGH__"